import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

type StylesType = {
  disabled: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    whiteSpace: 'nowrap',

    '& > div': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  }
}))

export default useStyles
